import { IAMPermission, useSgwtAuthentication } from '@sgwt/react-shared-libs';

interface ProtectedRouteProps {
  requiredPermissions: IAMPermission[];
  exceptions?: boolean;
  children: JSX.Element;
}

export const ProtectedRoute = ({ requiredPermissions, exceptions, children }: ProtectedRouteProps) => {
  const { hasSomePermissions } = useSgwtAuthentication();
  return hasSomePermissions(...requiredPermissions) || exceptions ? children : null;
};
